import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { AuditReviewStatus } from "root/DataFunctions/Constants";
import GlobalContext from "root/Contexts/GlobalContext";

const SectionStatus = {
    INCOMPLETE: 1,
    COMPLETE: 2,
    DONE: 3
}

const SectionLink = ({provider_id, year, rec, section, section_ref, provider_table_section_id, status, review_status, name, text }) =>
{
    const sessionContext = useContext( GlobalContext ) ;

    const TICK_ICON = '/app/style/image/complete.svg' ;
    const PENCIL_ICON = '/app/style/image/pencil-square.svg' ;

    const sectionIcon = (state) =>
    {
        switch (+state)
        {
            case SectionStatus.COMPLETE:

                if ( review_status === AuditReviewStatus.IN_REVIEW && sectionReviewRequired() )
                {
                    return PENCIL_ICON;
                }
                else
                {
                    return TICK_ICON;
                }
            case SectionStatus.INCOMPLETE:
                return PENCIL_ICON;
            case SectionStatus.DONE:
                return PENCIL_ICON;
            default:
                return PENCIL_ICON;
        }
    }

    const sectionReviewRequired = () =>
    {
        const amberCount = +(rec.amber) ;
        const redCount = +(rec.red) ;
        const inReviewCount = +(rec.in_review) ;

        const reviewRequired = ( amberCount !== 0 || redCount !== 0 ) && inReviewCount !== 0;

        return reviewRequired ;
    }

    const sectionClassName = (state) =>
    {
        switch ( review_status )
        {
            case AuditReviewStatus.IN_REVIEW:
                switch (+state)
                {
                    case SectionStatus.COMPLETE:
                        return sectionReviewRequired() ? ' review-required' : ' complete' ;
                    case SectionStatus.INCOMPLETE:
                            return '';
                    case SectionStatus.DONE:
                        return '';
                    default:
                        return '';
                }
            default:
                switch (+state)
                {
                    case SectionStatus.COMPLETE:
                        return ' complete';
                    case SectionStatus.INCOMPLETE:
                        return '';
                    case SectionStatus.DONE:
                        return '';
                    default:
                        return '';
                }
        }

    }

    const link = '/school/' + provider_id + '/year/' + year + '/section/' + provider_table_section_id + '?status=' + review_status ;

    const composeRef = () =>
    {
        const hasRef = rec.section_ref !== null ;

        const refText = hasRef ? rec.section_ref + '. ' : '' ;

        return refText ;
    }

    return (
        <Fragment>
            <div className={ 'standard-row-desktop' + sectionClassName(status) } >
                <div className='col-h-style'><span className='abbrev'> {sessionContext.getMobileSectionIcon(section, section_ref)}</span><span className='nonabbrev'>{ composeRef() + name }</span></div>
                <p className='col-h-text'>{text}</p>
                <Link to={link}><img src={sectionIcon(status)} alt="image"/></Link>
            </div>
        </Fragment>
    )
}

export default SectionLink ;
